import { render } from "./tabs.vue?vue&type=template&id=32160269&scoped=true"
import script from "./tabs.vue?vue&type=script&lang=js"
export * from "./tabs.vue?vue&type=script&lang=js"

import "./tabs.vue?vue&type=style&index=0&id=32160269&scoped=true&lang=css"

import exportComponent from "/Users/projects/crud/AVTO-SERVIS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32160269"]])

export default __exports__